import { useEffect } from 'react';
import { useDispatch, useBrandId } from 'AppProvider';
import { removeExperienceFromCart } from 'actions/cart';
import useListingsByIdsV3 from 'api/listing/useListingsByIdsV3';
import useCartItems from './useCartItems';

const useCartItemsListings = (includePendingItems = false) => {
  const dispatch = useDispatch();
  const brandId = useBrandId();

  const {
    cartId,
    cartItems,
    isLoading: isLoadingCart,
  } = useCartItems(includePendingItems);

  const {
    listings,
    isLoading: isLoadingListings,
    failedListingIds,
  } = useListingsByIdsV3({
    ids: Object.values(cartItems).map(
      (item) => item.listingId as string,
    ) as string[],
  });

  useEffect(() => {
    if (failedListingIds.length > 0) {
      // Find cart items that reference the failed listing IDs
      Object.values(cartItems).forEach((cartItem) => {
        const listingId = cartItem.listingId || cartItem.experienceId;
        if (failedListingIds.includes(listingId)) {
          dispatch(
            removeExperienceFromCart({
              cartItemId: cartItem.cartItemId,
              persistMeta: {
                brandId,
              },
            }),
          );
        }
      });
    }
  }, [failedListingIds, cartItems, brandId]);

  return {
    cartId,
    cartItems,
    listings,
    isLoading: isLoadingCart || isLoadingListings,
    isLoadingCart,
    isLoadingListings,
  };
};

export default useCartItemsListings;
